import * as React from 'react';
import { useLocation } from 'react-router';

import appUrls from 'base/app/urls';
import { Program } from 'base/api/types';
import { Container, Wrapper, TopBar } from 'common/components';
import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  StatusFilter,
  SearchInput,
  ContentRow,
} from 'templates/content';
import { ContentRowProps } from 'templates/content/components/ContentRow';
import { DetailsSwitch } from 'templates/details';
import { translate as t } from 'common/utils/translate';

import ProgramDetails from './ProgramDetails';
import { useProgramsList } from '../queries';

const fields = {
  search: 'search',
  filter: 'filter',
  sort: 'sort',
};

const ProgramsList = () => {
  const location = useLocation();
  const { data, isError } = useProgramsList();
  const context = {
    data: data?.values,
    path: {
      details: appUrls.LIFESTYLE_PROGRAMS.DETAILS,
      list: appUrls.LIFESTYLE_PROGRAMS.LIST,
    },
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title={t('Lifestyle Programs')}>
          <FiltersForm
            sort={['title', fields.sort]}
            search={['title', fields.search]}
            filter={['status', fields.filter]}
          >
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <StatusFilter name={fields.filter} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError}>{ProgramContentRow}</ContentList>
        <DetailsSwitch>
          <ProgramDetails key={location.pathname} />
        </DetailsSwitch>
      </ContentProvider>
    </Container>
  );
};

const ProgramContentRow = (props: ContentRowProps<Program>) => <ContentRow {...props} />;

export default ProgramsList;
